import { render, staticRenderFns } from "./oclock.vue?vue&type=template&id=77f8dc28&scoped=true&"
import script from "./oclock.vue?vue&type=script&lang=js&"
export * from "./oclock.vue?vue&type=script&lang=js&"
import style0 from "./oclock.vue?vue&type=style&index=0&id=77f8dc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8dc28",
  null
  
)

export default component.exports